import Image from 'next/image';
import React, { useState } from 'react';
import styled from 'styled-components';
import { WPTablistBlock } from '../../blocks/model/WPTalentpoolBlock';
import { device } from '../../styles/device';
import { TablistContainer, TablistWrapper, Tabnav, TabnavItems } from '../../styles/tablist/tablist';

const AgenturenContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-bottom: 64px;

    column-gap: 10px;
    row-gap: 10px;
    margin-left: 10px;
    margin-right: 10px;

    @media ${device.tablet} {
        column-gap: 12px;
        row-gap: 12px;
        margin-left: 12px;
        margin-right: 12px;
    }
    @media ${device.laptop} {
        column-gap: 16px;
        row-gap: 16px;
        margin-left: 16px;
        margin-right: 16px;
    }
`;

const AdressText = styled.p`
    margin-bottom: 20px;
    margin-top: 0px;
`;
const AgenturImageWrapper = styled.div`
    height: 97px;
    width: 172px;
    position: relative;
    border-radius: 12px;
    background-color: #FFFFFF;
    padding: 12px;

    @media ${device.tablet} {
        height: 150px;
        width: 258px;
        padding: 16px;
        border-radius: 16px;
    }
    @media ${device.laptop} {
        height: 220px;
        width: 377px;
        padding: 20px;
    }

    .img-wrapper {
        position: relative;
        height: 100%;
        width: 100%;
    }
`;

interface Agentur {
    event: string;
    name: string;
    logo: {
        sourceUrl: string
    };
    link?: string;
}
interface Event {
    city: string;
    date: string;
    agenturen?: any[];
    name: string;
}

/* function centerOnMobile(elementId) {
    if (window != undefined && window.innerWidth < 768) {
        const element = document.getElementById(elementId);
        const rect = element?.getBoundingClientRect();
        if (rect) {
            const container = document.getElementById("tablist-container");
            if (container) {
                const zeroLeft = rect.left + window.innerWidth;
                const offsetLeft = window.innerWidth - (rect.right - rect.left)
                const scrollToPx = zeroLeft - offsetLeft;
                container.animate([
                    // keyframes
                    { transform: 'translateX(' + scrollToPx + 'px)' }
                ], {
                    // timing options
                    duration: 300,
                    iterations: 1
                });
            }
        }

    }
}
 */

const setInital = (events): any[] => {
    const firstSelectedAgentur = events?.edges[0]?.node?.event?.agenturen;
    return firstSelectedAgentur != null ? firstSelectedAgentur : [];
}

export const Tablist = ({ block, events }) => {
    const [currentSelectedIndex, setCurrentSelectedIndex] = useState(0);
    const [agenturenBySelectedEvent, setAgenturen] = useState<any[]>(setInital(events));
    const attributes: WPTablistBlock = JSON.parse(block.attributesJSON);

    return (
        <TablistContainer>
            <h2>{attributes.title}</h2>
            <p className='subheader'>{attributes.description}</p>
            <TablistWrapper>
                <Tabnav>
                    <TabnavItems id="tablist-container" role="tablist">
                        {
                            events?.edges?.map((eventEdge, index) => {
                                const smeEvent: Event = eventEdge?.node?.event;

                                return (
                                    <li key={smeEvent.city + smeEvent.date} role="presentation">
                                        <a id={`${smeEvent.name}-tabnav-trigger-${index}`}
                                            href={`#event-item-${smeEvent.name}`}
                                            className={`${currentSelectedIndex === index ? "current " : ""}`}
                                            role="tab"
                                            tabIndex={currentSelectedIndex === index ? 0 : -1}
                                            aria-selected={currentSelectedIndex === index ? "true" : "false"}
                                            onClick={(event) => {
                                                event.preventDefault();
                                                setCurrentSelectedIndex(index);
                                                setAgenturen(smeEvent.agenturen != null ? smeEvent.agenturen : [])
                                                /*                                                 centerOnMobile(`${smeEvent.city}-tabnav-trigger`); */
                                            }}>
                                            {smeEvent.name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </TabnavItems>
                </Tabnav>
                <AdressText>
                    Standort des Events: {events.edges[currentSelectedIndex].node.event.adresse}
                </AdressText>
                <AgenturenContainer>
                    {
                        agenturenBySelectedEvent?.map((agenturEdge) => {
                            const agentur: Agentur = agenturEdge?.agentur;
                            return (
                                agentur.logo?.sourceUrl != null && (
                                    <AgenturImageWrapper key={agentur.name}>
                                        {
                                            agentur.link != null ?
                                                <a href={agentur?.link} target="_blank" rel="nofollow noopener noreferrer">
                                                    <div className='img-wrapper'>
                                                        <Image
                                                            src={agentur.logo?.sourceUrl}
                                                            alt={agentur.name + 'Logo Image'}
                                                            layout="fill"
                                                            objectFit='contain'
                                                        />
                                                    </div>
                                                </a>
                                                :
                                                <div className='img-wrapper'>
                                                    <Image
                                                        src={agentur.logo?.sourceUrl}
                                                        alt={agentur.name + 'Logo Image'}
                                                        layout="fill"
                                                        objectFit='contain'
                                                    />
                                                </div>
                                        }
                                    </AgenturImageWrapper>
                                )
                            );
                        })
                    }
                </AgenturenContainer>
            </TablistWrapper>
        </TablistContainer>
    );
}